import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=0dddb376"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dddb376')) {
      api.createRecord('0dddb376', component.options)
    } else {
      api.reload('0dddb376', component.options)
    }
    module.hot.accept("./GroupList.vue?vue&type=template&id=0dddb376", function () {
      api.rerender('0dddb376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/GroupList.vue"
export default component.exports